import React from "react";
import { Navigate } from "react-router-dom";
import { Layout } from "./Layout";
import { getMerchantToken } from "../services/api";

export function ProtectedLayout() {
  if (!getMerchantToken()) {
    return <Navigate to="/login" replace />;
  }
  return <Layout />;
}
